import PulseScope from '@/shared/components/PulseScope/PulseScope'
import FidelityJourney from './FidelityJourney/FidelityJourney'
import LegacyFidelity from './LegacyFidelity/LegacyFidelity'
import useFidelityMaximizer from './useFidelityMaximizer'

const FidelityMaximizer = () => {
  const { hidden, legacy, journey } = useFidelityMaximizer()

  if (hidden) {
    return null
  }

  return (
    <>
      <LegacyFidelity {...legacy} />
      <PulseScope enabled={true}>
        <FidelityJourney {...journey} />
      </PulseScope>
    </>
  )
}

export default FidelityMaximizer
